/* Bull Ring Fabrics — head scripts, part 1 of 4 (2026-10-31, Abid). Scripts that used to be printed inline into the <head> of every
   page by the snippets named below (rendered from snippets/brf-local-business-schema). Moved into cached files. Loaded without defer,
   in order, at the same point in the head, so they run exactly when they used to. Each block is marked with the snippet it came from. */

/* ===== from snippets/(variant pre-render fix, not from a snippet).liquid ===== */
/* Variant picker (Warehouse 7, assets/theme.js): when the colour picker scrolls into view the theme fetched a full copy of the product
   section for EVERY colour (36 fetches and 13 MB on Plain Satin) to pre-render them. That idle-time pre-render is stopped here; the
   theme still pre-renders the one colour the shopper hovers or touches, so switching colour stays instant. (2026-10-31, Abid) */
(function () {
  var ric = window.requestIdleCallback; if (!ric) return;
  window.requestIdleCallback = function (cb, opts) {
    try { if (typeof cb === 'function' && /renderForCombination_fn/.test(Function.prototype.toString.call(cb))) return 0; } catch (e) {}
    return ric.call(window, cb, opts);
  };
})();

/* ===== from snippets/brf-qv-slate.liquid ===== */
/* Quick view only (14:42, Abid): sold-out designs / options are hidden, so only in-stock choices show.
   Reads the variants from the quick view's own product JSON; the product page itself is untouched. */
(function(){
  function fire(el){ el.dispatchEvent(new Event('change', {bubbles: true})); }
  function run(m, json){
    var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
    var vs = (data.product && data.product.variants) || [];
    if (!vs.some(function(v){ return v.available; })) return; /* whole product sold out: leave it alone */
    function ok(pos, val){ return vs.some(function(v){ return v.available && v['option' + pos] === val; }); }
    m.querySelectorAll('select.product-form__single-selector[data-option-position]').forEach(function(sel){
      var pos = sel.getAttribute('data-option-position'), was = sel.value, keep = null;
      Array.prototype.slice.call(sel.options).forEach(function(o){ if (!ok(pos, o.value)) o.remove(); else if (keep == null) keep = o.value; });
      if (keep != null && !ok(pos, was)) { sel.value = keep; fire(sel); }
    });
    var groups = {};
    m.querySelectorAll('input.product-form__single-selector[type=radio][data-option-position]').forEach(function(r){
      var pos = r.getAttribute('data-option-position'), box = r.closest('.block-swatch,.color-swatch,.variant-swatch') || r.parentNode;
      (groups[r.name] = groups[r.name] || []).push(r);
      if (!ok(pos, r.value)) { box.style.display = 'none'; r.__brfOut = true; }
    });
    Object.keys(groups).forEach(function(n){
      var g = groups[n], on = g.filter(function(r){ return r.checked; })[0], first = g.filter(function(r){ return !r.__brfOut; })[0];
      if (on && on.__brfOut && first) { first.checked = true; fire(first); }
    });
  }
  /* Clearpay line: the quick view is added after page load, so make sure our pay-in-4 line shows there */
  function showCp(m){
    m.querySelectorAll('[data-brf-cpwrap]').forEach(function(w){ w.classList.remove('is-waiting', 'is-official'); });
  }
  /* compact dispatch countdown + free delivery progress under the photo (14:47, Abid). Same rules as brf-pdp-dispatch:
     same-day dispatch Mon–Fri before 9pm UK, bank holidays off, free tracked UK delivery over £65 */
  var HOL = ['2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28'];
  var DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'], CUT = 21, FREE = 6500, lf;
  function london(d){
    lf = lf || new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hour12:false, weekday:'short'});
    var p = {}; lf.formatToParts(d).forEach(function(x){ p[x.type] = x.value; });
    return {ymd: p.year + '-' + p.month + '-' + p.day, wd: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(p.weekday), h: parseInt(p.hour, 10) % 24, m: +p.minute, s: +p.second};
  }
  function work(L){ return L.wd >= 1 && L.wd <= 5 && HOL.indexOf(L.ymd) < 0; }
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function dispatch(m, data){
    var g = m.querySelector('.product-gallery'); if (!g || m.querySelector('.brf-qvd')) return;
    var vs = (data.product && data.product.variants) || []; if (!vs.some(function(v){ return v.available; })) return;
    var box = document.createElement('div'); box.className = 'brf-dispatch brf-qvd';
    box.innerHTML = '<div class="brf-qvd__row"><span class="brf-qvd__ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg></span>'
      + '<div class="brf-qvd__t"><b data-t></b><span data-s></span></div><div class="brf-qvd__clock" data-c hidden><i data-h>00</i><em>:</em><i data-m>00</i><em>:</em><i data-x>00</i></div></div>'
      + '<div class="brf-qvd__free" data-f hidden><div data-ft></div><div class="brf-qvd__bar"><span data-fb style="width:0%"></span></div></div>';
    g.parentNode.insertBefore(box, g.nextSibling);
    var q = function(k){ return box.querySelector('[data-' + k + ']'); };
    function tick(){
      if (!box.isConnected) return clearInterval(iv);
      var now = new Date(), L = london(now), secs = L.h * 3600 + L.m * 60 + L.s, cut = CUT * 3600;
      if (work(L) && secs < cut) {
        var left = cut - secs, h = Math.floor(left / 3600), mi = Math.floor(left % 3600 / 60);
        /* wording 2026-10-23 (Abid): reads into the countdown beside it, e.g. "Get it dispatched today / Order within the next 02:15:47" */
        q('t').innerHTML = '<i class="brf-qvd__live"></i>Get it dispatched today';
        q('s').textContent = 'Order within the next';
        q('h').textContent = pad(h); q('m').textContent = pad(mi); q('x').textContent = pad(left % 60); q('c').hidden = false;
      } else {
        var next = 'next working day';
        for (var i = 1; i <= 10; i++) { var t = london(new Date(now.getTime() + i * 864e5)); if (work(t)) { next = i === 1 ? 'tomorrow' : 'on ' + DAYS[t.wd]; break; } }
        q('t').textContent = 'Order now for dispatch ' + next;
        q('s').textContent = 'Same-day dispatch Mon–Fri before 9pm.';
        q('c').hidden = true;
      }
    }
    var iv = setInterval(tick, 1000); tick();
    fetch('/cart.js', {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(function(c){
      if (c.currency && c.currency !== 'GBP') return;
      var t = c.total_price || 0, money = function(p){ return '£' + (p / 100).toFixed(2).replace(/\.00$/, ''); };
      q('ft').innerHTML = t >= FREE ? '<strong>You’ve unlocked free tracked UK delivery</strong>'
        : t > 0 ? 'Add <strong>' + money(FREE - t) + '</strong> more for <strong>free tracked UK delivery</strong>'
        : '<strong>Free tracked UK delivery</strong> on orders over £65';
      q('fb').style.width = (t > 0 ? Math.max(4, Math.min(100, Math.round(t / FREE * 100))) : 0) + '%';
      q('f').hidden = false;
    }).catch(function(){});
  }
  /* compact "Why we love it" note under the dispatch box (15:00, Abid); the text comes from templates/product.quick-view */
  function love(m){
    var t = m.querySelector('template[data-brf-qv-love]'); if (!t || m.querySelector('.brf-qvlove')) return;
    var at = m.querySelector('.brf-qvd') || m.querySelector('.product-gallery'); if (!at) return;
    var box = document.createElement('div'); box.className = 'brf-qvlove';
    box.innerHTML = '<div class="brf-qvlove__h"><svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.3C.9 8.2 3.1 4.5 6.8 4.5c2.1 0 3.6 1.1 5.2 3 1.6-1.9 3.1-3 5.2-3 3.7 0 5.9 3.7 4.4 7.2C19.5 16.4 12 21 12 21z"/></svg>Why we love it</div>'
      + '<div class="brf-qvlove__p">' + t.innerHTML + '</div><div class="brf-qvlove__by">Our own pick, written by the Bullring Fabrics team</div>';
    at.parentNode.insertBefore(box, at.nextSibling);
  }
  /* option C photo glow: one blurred copy of the photo on show behind the glass. It follows the slide that's selected,
     so picking another colour (or swiping the photos) changes the glow too (Abid, 2026-10-14) */
  function glow(m){
    var d = m.querySelector('.modal__dialog'); if (!d) return;
    var img = m.querySelector('.product-gallery__carousel-item.is-selected img') || m.querySelector('.product-gallery__carousel img, .product-gallery img'); if (!img) return;
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0) { src = (img.getAttribute('data-src') || img.getAttribute('data-zoom') || '').replace('{width}', '400'); }
    if (!src) return;
    var g = d.querySelector(':scope > .brf-qvglow');
    if (!g) { g = document.createElement('div'); g.className = 'brf-qvglow'; g.setAttribute('aria-hidden', 'true'); g.innerHTML = '<i></i>'; d.insertBefore(g, d.firstChild); }
    if (g.__src === src) return;
    g.__src = src; g.classList.remove('is-on');
    var u = 'url("' + src.replace(/"/g, '%22') + '")';
    g.firstChild.style.backgroundImage = u + ',' + u;
    var pre = new Image(); pre.onload = function(){ if (g.__src === src) g.classList.add('is-on'); }; pre.src = src;
  }
  /* "View full details" link under the buy buttons (14:56, Abid) */
  function fullLink(m, data){
    var h = data.product && data.product.handle; if (!h || m.querySelector('.brf-qvfull')) return;
    var a = document.createElement('a'); a.className = 'brf-qvfull'; a.href = '/products/' + h;
    a.innerHTML = 'View full details <svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true"><path d="M4.5 2.5 8 6 4.5 9.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var pay = m.querySelector('.product-form__payment-container'), form = m.querySelector('form.product-form') || m.querySelector('.product-form');
    if (pay) pay.parentNode.insertBefore(a, pay.nextSibling); else if (form) form.appendChild(a);
  }
  setInterval(function(){
    document.querySelectorAll('.modal[id^="modal-quick-view"]').forEach(function(m){
      showCp(m); glow(m);
      var json = m.querySelector('script[data-product-json]');
      if (!json || json.__brfOos) return;
      json.__brfOos = true;
      setTimeout(function(){ run(m, json); try { var d = JSON.parse(json.textContent); dispatch(m, d); love(m); fullLink(m, d); } catch (e) {} }, 350); /* let the theme wire up its selectors first */
    });
  }, 300);
})();

/* ===== from snippets/brf-qv-delivery.liquid ===== */
(function(){
  var doc = document, FREE = 6500, t0 = 0;
  function money(p){ return '£' + (p / 100).toFixed(2).replace(/\.00$/, ''); }
  function paint(c){
    if (!c || (c.currency && c.currency !== 'GBP')) return;
    var t = c.total_price || 0;
    doc.querySelectorAll('.modal[id^="modal-quick-view"] .brf-qvd__free').forEach(function(f){
      var ft = f.querySelector('[data-ft]'), fb = f.querySelector('[data-fb]'); if (!ft || !fb) return;
      ft.innerHTML = t >= FREE ? '<strong>You’ve unlocked free tracked UK delivery</strong> 🎉'
        : t > 0 ? 'Add <strong>' + money(FREE - t) + '</strong> more for <strong>free tracked UK delivery</strong>'
        : '<strong>Free tracked UK delivery</strong> on orders over £65';
      fb.style.width = (t > 0 ? Math.max(4, Math.min(100, Math.round(t / FREE * 100))) : 0) + '%';
      var sd = f.querySelector('.brf-qvd__std');
      if (t < FREE) {
        if (!sd) { sd = doc.createElement('div'); sd.className = 'brf-qvd__std'; f.appendChild(sd); }
        sd.innerHTML = 'Under £65, standard tracked UK delivery is <strong>£3.99</strong>';
      } else if (sd) sd.remove();
      f.setAttribute('data-brf-std', '');
      f.hidden = false;
    });
  }
  function bag(){ fetch('/cart.js', {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(paint).catch(function(){}); }
  /* window capture runs before the quick view's own add listeners stop the event */
  window.addEventListener('product:added', function(e){
    var m = e.target && e.target.closest && e.target.closest('.modal[id^="modal-quick-view"]'); if (!m) return;
    clearTimeout(t0); t0 = setTimeout(bag, 250);
  }, true);
  /* when the card first shows its bag line, add the £3.99 note */
  function look(){
    var f = doc.querySelector('.modal[id^="modal-quick-view"] .brf-qvd__free:not([hidden]):not([data-brf-std])');
    if (f) { f.setAttribute('data-brf-std', ''); bag(); }
  }
  function boot(){ if (window.MutationObserver) new MutationObserver(look).observe(doc.body, {childList: true, subtree: true}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ===== from snippets/brf-qv-close.liquid ===== */
(function(){
  if (window.__brfQvClose) return; window.__brfQvClose = true;
  var doc = document;
  function shut(m){
    if (m.getAttribute('aria-hidden') !== 'false') return;
    m.setAttribute('aria-hidden', 'true');
    m.dispatchEvent(new CustomEvent('modal:closed'));
    if (!doc.querySelector('.modal[aria-hidden="false"]')) doc.documentElement.classList.remove('is-locked');
  }
  doc.addEventListener('click', function(e){
    var x = e.target.closest && e.target.closest('[data-action="close-modal"]'); if (!x) return;
    var m = x.closest('.modal[id^="modal-quick-view"]'); if (!m) return;
    setTimeout(function(){ shut(m); }, 60);
  }, true);
})();

/* ===== from snippets/brf-rw-fix.liquid ===== */
(function(){
  if (window.__brfRwFix) return; window.__brfRwFix = true;
  var doc = document, root = doc.documentElement;
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="8" width="17" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.6-3.2-5.4-3.6-5.4-1.2C6.6 8 9 8 12 8zM12 8c1.6-3.2 5.4-3.6 5.4-1.2C17.4 8 15 8 12 8z"/></svg>';
  function tag(f){ var p = f.parentElement; return [f.id, f.className, f.title, f.name, f.getAttribute('src'), p && p.id, p && p.className].join(' '); }
  /* Smile's launcher button frames (lite or full), never its panel */
  function launchers(){
    return [].filter.call(doc.querySelectorAll('iframe'), function(f){
      var t = tag(f); return /smile/i.test(t) && /launcher/i.test(t) && !/panel/i.test(f.id + ' ' + f.className + ' ' + f.title);
    });
  }
  var cv;
  function textW(px, fam){ cv = cv || doc.createElement('canvas'); var x = cv.getContext('2d'); x.font = '600 ' + px + 'px ' + fam; return x.measureText('Rewards').width; }
  function setCls(el, c, on){ if (el.classList.contains(c) !== on) el.classList.toggle(c, on); }
  /* full pill: 16px padding each side, 19px icon, 7px gap; tight: 10px, 16px, 5px; text only: 8px; plus the 1px border */
  function fit(pill, w, round){
    var fam = getComputedStyle(pill).fontFamily, full = textW(14, fam) + 19 + 7 + 34, tight = textW(13, fam) + 16 + 5 + 22, text = textW(12.5, fam) + 18;
    var tooSmall = !round && w > 0 && w < full;
    setCls(pill, 'is-tight', tooSmall && w >= tight);
    setCls(pill, 'is-text', tooSmall && w < tight && w >= text);
    setCls(pill, 'is-icon', tooSmall && w < text);
  }
  function run(){
    launchers().forEach(function(f){
      var box = f.parentElement; if (!box || box === doc.body) return;
      setCls(box, 'brf-rw-host', true);
      var pill = box.querySelector(':scope > .brf-rw');
      if (!pill) {
        pill = doc.createElement('span'); pill.className = 'brf-rw'; pill.setAttribute('aria-hidden', 'true');
        pill.innerHTML = GIFT + '<span>Rewards</span>';
        if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
        box.insertBefore(pill, box.firstChild);
      }
      setCls(root, 'brf-rw-on', true);
      var r = box.getBoundingClientRect(), round = r.width > 0 && r.width < r.height * 1.6;
      setCls(pill, 'is-round', round);
      fit(pill, r.width, round);
      unclash(box);
    });
  }
  /* walk up through shadow roots too */
  function up(el){ return el.parentElement || (el.getRootNode && el.getRootNode().host) || null; }
  function fixedOf(el){ for (; el && el !== doc.body && el !== root; el = up(el)) if (getComputedStyle(el).position === 'fixed') return el; return null; }
  function hits(a, b){ return a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom; }
  function small(r){ return r.width > 0 && r.height > 0 && r.width <= 260 && r.height <= 160; }
  /* everything under a point, including inside other apps' open shadow roots */
  function under(x, y, list){
    var els = doc.elementsFromPoint(x, y), i, sr;
    for (i = 0; i < els.length; i++) { list.push(els[i]); sr = els[i].shadowRoot; if (sr && sr.elementsFromPoint) [].push.apply(list, sr.elementsFromPoint(x, y)); }
  }
  /* Lift any other app's little floating button that overlaps the Rewards pill so it sits 10px above it.
     (2026-10-20) The round "<" tab kept slipping through: its fixed holder has no size of its own (or lives in a shadow root),
     so now the tab itself is measured, and the biggest still-small box around it is moved up with `translate`, which
     leaves the app's own position and animations alone. */
  function unclash(box){
    if (root.classList.contains('brf-smile-open') || !doc.elementsFromPoint) return;
    var host = fixedOf(box) || box, hr = host.getBoundingClientRect();
    if (!hr.width || !hr.height) return;
    var cand = [], done = [];
    for (var x = hr.left + 4; x <= hr.right + 40; x += 8) [.2, .5, .8].forEach(function(k){ under(x, hr.top + hr.height * k, cand); });
    [].push.apply(cand, doc.querySelectorAll('[data-brf-lift-y]'));
    /* speed (2026-10-24): every probe point returns the same page layers again, so measure each element once */
    var once = new Set(); cand = cand.filter(function(el){ if (once.has(el)) return false; once.add(el); return true; });
    cand.forEach(function(el){
      if (el === host || host.contains(el) || el.contains(host) || el === doc.body || el === root) return;
      var f = fixedOf(el); if (!f || f === host || f.contains(host) || host.contains(f)) return;
      if (f.classList.contains('brf-rw-host') || f.querySelector('.brf-rw-host')) return; /* another Smile launcher box */
      var fr = f.getBoundingClientRect(); if (fr.width * fr.height > 0 && !small(fr)) return; /* a big bar (cookie banner etc.): leave it */
      /* the outermost box around el that is still a small button */
      var mv = null, n = el;
      for (; n; n = up(n)) { var nr = n.getBoundingClientRect(); if (small(nr)) mv = n; else if (nr.width * nr.height > 0) break; if (n === f) break; }
      if (!mv || done.indexOf(mv) > -1 || mv.contains(host)) return;
      done.push(mv);
      var lifted = +(mv.getAttribute('data-brf-lift-y') || 0), r = mv.getBoundingClientRect(), bottom = r.bottom + lifted;
      if (!lifted && !hits(r, hr)) return;
      var need = Math.max(0, Math.round(bottom - hr.top + 10));
      if (need === lifted) return;
      mv.setAttribute('data-brf-lift-y', need);
      mv.style.setProperty('translate', '0 ' + (-need) + 'px', 'important');
      mv.style.setProperty('transition', 'translate .3s ease');
    });
  }
  var t = 0;
  function soon(recs){
    /* speed (2026-10-24): ignore the style changes this script makes itself when it lifts a button */
    if (recs && recs.length && recs.every(function(m){ return m.type === 'attributes' && m.target.hasAttribute && m.target.hasAttribute('data-brf-lift-y'); })) return;
    /* speed (2026-10-24): page content filling in (gallery, reviews, recommendations) can't add a floating button, so new nodes inside <main> don't re-measure */
    var main = doc.getElementById('main');
    if (recs && recs.length && recs.every(function(m){
      if (m.type !== 'childList') return false;
      if (main && main.contains(m.target)) return true;
      /* text swaps (prices, counters) add no boxes */
      for (var i = 0; i < m.addedNodes.length; i++) if (m.addedNodes[i].nodeType === 1) return false;
      for (i = 0; i < m.removedNodes.length; i++) if (m.removedNodes[i].nodeType === 1) return false;
      return true;
    })) return;
    clearTimeout(t); t = setTimeout(run, 120);
  }
  function start(){
    run();
    if (window.MutationObserver) new MutationObserver(soon).observe(doc.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style']});
    window.addEventListener('resize', function(){ soon(); });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(function(){ soon(); });
  }
  if (doc.body) start(); else doc.addEventListener('DOMContentLoaded', start);
})();

/* ===== from snippets/brf-dispatch-compact.liquid ===== */
(function(){
  if (window.__brfDispatchStd) return; window.__brfDispatchStd = 1;
  function fix(free){
    if (free.closest('.brf-qvd, .modal')) return;
    var p = free.querySelector('.brf-dispatch__std');
    if (!p) { p = document.createElement('p'); p.className = 'brf-dispatch__std'; p.innerHTML = 'Under £65, standard tracked UK delivery is <strong>£3.99</strong>.'; free.appendChild(p); }
    var t = free.querySelector('[data-brf-free-text]'), on = !(t && /unlocked/i.test(t.textContent));
    if (p.hidden === on) p.hidden = !on;
  }
  function run(){ [].forEach.call(document.querySelectorAll('.brf-dispatch [data-brf-free]'), fix); }
  /* ring: share of the 12 hours before the 9pm cut-off that is still left */
  function ring(){
    [].forEach.call(document.querySelectorAll('.brf-dispatch [data-brf-dispatch-clock]'), function(c){
      var h = c.querySelector('[data-h]'), m = c.querySelector('[data-m]'), s = c.querySelector('[data-s]'); if (!h || !m || !s) return;
      var left = (+h.textContent || 0) * 3600 + (+m.textContent || 0) * 60 + (+s.textContent || 0);
      c.style.setProperty('--brf-p', Math.max(.02, Math.min(1, left / 43200)).toFixed(4));
    });
  }
  function start(){
    run(); ring(); setInterval(ring, 1000);
    [].forEach.call(document.querySelectorAll('.brf-dispatch [data-brf-free-text]'), function(t){
      if (window.MutationObserver) new MutationObserver(run).observe(t, {childList: true, characterData: true, subtree: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* ===== from snippets/brf-ann-klarna.liquid ===== */
(function(){
  function add(){
    var t=document.getElementById('brf-ann-kl');if(!t)return;
    document.querySelectorAll('.brf-ann__item--cp .brf-ann__cplogo').forEach(function(cp){
      if(cp.parentNode.querySelector('.brf-ann__kl'))return;
      cp.after(t.content.cloneNode(true));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',add);else add();
})();

/* ===== from snippets/brf-chat-live.liquid ===== */
(function(){
  var LS='brf-chat-live',TTL=12*36e5,html=document.documentElement;
  function ss(k){try{return sessionStorage.getItem(k)}catch(e){return null}}
  function lsGet(){try{return +localStorage.getItem(LS)||0}catch(e){return 0}}
  function lsSet(v){try{v?localStorage.setItem(LS,String(Date.now())):localStorage.removeItem(LS)}catch(e){}}
  var active=ss('shopify-chat-populated')==='true'||(Date.now()-lsGet()<TTL);

  /* Lift the homepage hide for chat (keep Rewards hidden) when a conversation is going */
  function liftHomeHide(){
    var st=document.getElementsByTagName('style');
    for(var i=0;i<st.length;i++){
      var t=st[i].textContent;
      if(t.indexOf('smile-ui-lite-launcher-frame-container')>-1&&t.indexOf('shopify-chat,#shopify-chat,')>-1){
        st[i].textContent=t.replace('shopify-chat,#shopify-chat,','');
      }
    }
  }
  if(active){html.classList.add('brf-chat-live');liftHomeHide();}

  var unread=0,ac=null,lastPing=0,bornAt=Date.now(),halo,badge,pill,timer;

  function chat(){return document.querySelector('shopify-chat')}
  function isOpen(){var c=chat();return !!(c&&(c.open||c.hasAttribute('open')))}
  function launcher(){
    var seen=0;
    function walk(root){
      if(!root||seen++>400)return null;
      var b=root.querySelectorAll('button,[role="button"]');
      for(var i=0;i<b.length;i++){var l=(b[i].getAttribute('aria-label')||'');if(/chat/i.test(l)&&b[i].getBoundingClientRect().width>0)return b[i];}
      var all=root.querySelectorAll('*');
      for(var j=0;j<all.length;j++){if(all[j].shadowRoot){var f=walk(all[j].shadowRoot);if(f)return f;}}
      return null;
    }
    var c=chat();return c?walk(c.shadowRoot||c):null;
  }

  function build(){
    if(halo)return;
    halo=document.createElement('div');halo.className='brf-chat-halo';halo.setAttribute('aria-hidden','true');
    halo.innerHTML='<span class="brf-chat-halo__ring"></span><span class="brf-chat-halo__dot"></span><span class="brf-chat-halo__badge"></span>';
    badge=halo.querySelector('.brf-chat-halo__badge');
    pill=document.createElement('button');pill.type='button';pill.className='brf-chat-pill';
    pill.innerHTML='<span class="brf-chat-pill__dot"></span><span class="brf-chat-pill__t">New reply from the Bullring team</span><span class="brf-chat-pill__go">Read</span>';
    pill.addEventListener('click',function(){var c=chat();try{c&&c.show&&c.show()}catch(e){}clearUnread();});
    document.body.appendChild(halo);document.body.appendChild(pill);
  }

  function place(){
    if(!halo)return;
    var show=active&&!isOpen(),b=show&&launcher(),r=b&&b.getBoundingClientRect();
    if(!r||!r.width){halo.classList.remove('is-on');pill.classList.remove('is-on');return;}
    var s=Math.max(r.width,r.height);
    halo.style.width=halo.style.height=s+'px';
    halo.style.left=(r.left+r.width/2-s/2)+'px';halo.style.top=(r.top+r.height/2-s/2)+'px';
    halo.classList.add('is-on');
    if(unread){
      var right=window.innerWidth-r.right,onRight=r.left>window.innerWidth/2;
      pill.style.bottom=(window.innerHeight-r.top+12)+'px';
      pill.style.left=onRight?'auto':Math.max(12,r.left)+'px';
      pill.style.right=onRight?Math.max(12,right)+'px':'auto';
      pill.classList.add('is-on');
    }else pill.classList.remove('is-on');
  }

  function start(){
    build();
    if(!timer)timer=setInterval(place,350);
    place();
  }
  function setActive(v){
    if(v===active&&(!v||timer))return;
    active=v;lsSet(v);
    html.classList.toggle('brf-chat-live',v);
    if(v){liftHomeHide();start();}else{clearUnread();if(timer){clearInterval(timer);timer=null;}place();}
  }

  /* Chime: two soft bell notes with a sparkle, made in the browser (no sound file) */
  function unlock(){
    try{
      if(!ac){var A=window.AudioContext||window.webkitAudioContext;if(A)ac=new A();}
      if(ac&&ac.state!=='running')ac.resume();
    }catch(e){}
  }
  /* iPhone Safari only unlocks sound on touchend / click, Chrome on pointerdown / keydown */
  ['pointerdown','keydown','touchend','click'].forEach(function(t){window.addEventListener(t,unlock,{capture:true,passive:true});});
  function chime(vol){
    if(!ac)return;
    try{
      if(ac.state==='suspended')ac.resume();
      var t0=ac.currentTime+.02,out=ac.createGain();out.gain.value=vol;out.connect(ac.destination);
      [[1318.5,0],[1760,.13],[2637,.26]].forEach(function(n,i){
        var o=ac.createOscillator(),g=ac.createGain(),t=t0+n[1];
        o.type='sine';o.frequency.value=n[0];
        g.gain.setValueAtTime(0,t);g.gain.linearRampToValueAtTime(i==2?.35:1,t+.012);g.gain.exponentialRampToValueAtTime(.0008,t+(i==2?.5:.9));
        o.connect(g);g.connect(out);o.start(t);o.stop(t+1);
      });
    }catch(e){}
  }

  function clearUnread(){unread=0;if(badge)badge.textContent='';if(halo)halo.classList.remove('has-unread');if(pill)pill.classList.remove('is-on');}

  function onReply(){
    setActive(true);
    var now=Date.now();
    if(now-bornAt<4000||now-lastPing<1500)return; /* skip history replayed on page load */
    lastPing=now;
    var away=!isOpen()||document.hidden;
    chime(away?.22:.1);
    if(away){
      unread++;build();
      badge.textContent=unread>9?'9+':String(unread);
      halo.classList.add('has-unread');
      halo.classList.remove('is-bump');void halo.offsetWidth;halo.classList.add('is-bump');
      try{navigator.vibrate&&navigator.vibrate([30,60,30])}catch(e){}
      place();
    }
  }

  var on=function(n,f){document.addEventListener('shopify-chat:'+n,f,true)};
  on('populated',function(){setActive(true)});
  on('user-sent',function(){setActive(true)});
  on('inbox-message-received',onReply);
  on('empty-state',function(e){var d=e.detail||{};if(d.visible===false)setActive(true);});
  on('conversation-cleared',function(){setActive(false)});
  on('open-requested',function(){clearUnread()});

  function watchOpen(){
    var c=chat();if(!c){return setTimeout(watchOpen,800);}
    new MutationObserver(function(){if(isOpen())clearUnread();place();}).observe(c,{attributes:true,attributeFilter:['open']});
  }
  function boot(){if(active)start();watchOpen();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  /* Shopify sets this flag itself once a conversation has messages */
  setInterval(function(){if(!active&&ss('shopify-chat-populated')==='true')setActive(true);},2000);
})();

/* ===== from snippets/brf-card-left.liquid ===== */
(function(){
  if (window.__brfCardLeft) return; window.__brfCardLeft = true;
  var doc = document;
  function txt(n, u){ u = u || ''; return n <= 5 ? 'Only ' + n + u + ' left' : n + u + ' left'; }
  function show(sel){
    var pick = sel.closest('.brf-ucard__pick'); if (!pick) return;
    var el = pick.querySelector('.brf-ucard__left');
    if (!el) { el = doc.createElement('span'); el.className = 'brf-ucard__left'; el.setAttribute('aria-live', 'polite'); pick.insertBefore(el, pick.querySelector('svg')); }
    var o = sel.options[sel.selectedIndex], n = o ? parseInt(o.getAttribute('data-max'), 10) : NaN;
    el.textContent = isNaN(n) ? '' : txt(n, sel.getAttribute('data-u'));
    el.classList.toggle('is-low', !isNaN(n) && n <= 5);
    el.classList.toggle('is-ok', !isNaN(n) && n > 5);
  }
  function all(){ [].forEach.call(doc.querySelectorAll('select[data-brf-pick]'), function(s){ if (!s.__brfLeft) { s.__brfLeft = 1; show(s); } }); }
  doc.addEventListener('change', function(e){ var t = e.target; if (t && t.matches && t.matches('select[data-brf-pick]')) show(t); });
  /* stock next to each option in the open list on computers */
  function menuCounts(m){
    var sel = doc.activeElement; if (!sel || !sel.matches || !sel.matches('select[data-brf-pick]')) return;
    [].forEach.call(m.querySelectorAll('.brf-pickmenu__o'), function(b){
      var o = sel.options[parseInt(b.getAttribute('data-i'), 10)], n = o ? parseInt(o.getAttribute('data-max'), 10) : NaN;
      if (isNaN(n) || b.querySelector('.brf-pickmenu__n')) return;
      var s = doc.createElement('span'); s.className = 'brf-pickmenu__n' + (n <= 5 ? ' is-low' : ''); s.textContent = txt(n, sel.getAttribute('data-u')); b.appendChild(s);
    });
  }
  var t = 0;
  new MutationObserver(function(ms){
    for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
      var n = ms[i].addedNodes[j];
      if (n.nodeType === 1 && n.classList.contains('brf-pickmenu')) menuCounts(n);
    }
    clearTimeout(t); t = setTimeout(all, 120);
  }).observe(doc.documentElement, {childList: true, subtree: true});
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', all); else all();
})();

/* ===== from snippets/brf-ft-clip.liquid ===== */
(function(){
  /* The extension's box (div#app > .tcb-extension--mobile) lives inside the extension's own shadow root, so plain
     selectors and page CSS never reach it (Abid's 02:37 readout: seen 0). Every open shadow root is searched; the box is
     pinned with inline styles to a fixed spot just below the screen, where it can't lengthen the page, and its shadow
     host is parked in a fixed, zero-height holder as well. window.__brfTcb counts what happened. */
  var T = window.__brfTcb = {seen: 0, fixed: 0, moved: 0, ran: 1};
  function holder(){
    var h = document.getElementById('brf-xt');
    if (!h) { h = document.createElement('div'); h.id = 'brf-xt'; h.style.cssText = 'position:fixed!important;left:0!important;top:100%!important;width:100%!important;height:0!important;overflow:visible!important;margin:0!important;padding:0!important'; document.documentElement.appendChild(h); }
    return h;
  }
  function pin(el){
    var st = el.style;
    if (st.getPropertyValue('top') === '100%') return;
    st.setProperty('position', 'fixed', 'important'); st.setProperty('top', '100%', 'important'); st.setProperty('left', '0', 'important');
    st.setProperty('width', '100%', 'important'); st.setProperty('margin', '0', 'important'); T.fixed++;
  }
  function hide(){
    (function scan(root, host){
      var x = root.querySelectorAll('.tcb-extension');
      for (var i = 0; i < x.length; i++) {
        T.seen++; var a = x[i].closest('#app') || x[i]; pin(a);
        if (host && host.getRootNode() === document && host.parentNode && host.parentNode.id !== 'brf-xt' && T.moved < 30) { holder().appendChild(host); T.moved++; T.host = host.tagName.toLowerCase(); }
      }
      var all = root.querySelectorAll('*');
      for (var j = 0; j < all.length; j++) if (all[j].shadowRoot) scan(all[j].shadowRoot, host || all[j]);
    })(document, null);
  }
  new MutationObserver(hide).observe(document.documentElement, {childList: true, subtree: true});
  var k = 0, iv = setInterval(function(){ hide(); if (++k > 40) clearInterval(iv); }, 500);
  var sd; window.addEventListener('scroll', function(){ clearTimeout(sd); sd = setTimeout(hide, 200); }, {passive: true}); /* the extension can add its box late */
  document.addEventListener('DOMContentLoaded', hide); window.addEventListener('load', hide);
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 2026-10-30 (Abid): tips stay up long enough to read: about 6s, plus ~0.4s a word for longer ones (max 15s).
   The countdown pauses while the pointer or a finger is on the tip, and a tap closes it. */
window.brfReadMs = window.brfReadMs || function(el){ var n = ((el && el.textContent) || '').trim().split(/\s+/).length; return Math.min(15000, Math.max(6000, 2500 + n * 400)); };
window.brfTipLife = window.brfTipLife || function(el, gone){
  var t = 0, left = window.brfReadMs(el), start = Date.now();
  function arm(ms){ clearTimeout(t); start = Date.now(); left = ms; t = setTimeout(gone, ms); }
  el.addEventListener('mouseenter', function(){ clearTimeout(t); left = Math.max(2500, left - (Date.now() - start)); });
  el.addEventListener('mouseleave', function(){ arm(left); });
  el.addEventListener('click', function(){ clearTimeout(t); gone(); });
  arm(left);
  return start;
};

/* ===== from snippets/brf-load-calm.liquid ===== */
(function(){
  if (window.__brfLoadCalm) return; window.__brfLoadCalm = 1;
  try { localStorage.setItem('pushowl_install_prompt_dismissed', '1'); } catch (e) {}
  /* same rules brf-x-ux-mobile.js injects (style id brf-ux-chat, so it won't add them twice) */
  var CSS = ':host .activator-nudge{opacity:var(--brf-float-op,1)!important;visibility:var(--brf-float-vis,visible)!important;pointer-events:var(--brf-float-pe,auto)!important}'
    + '@media (max-width:767px){'
    + ':host .activator-nudge{right:14px!important;bottom:calc(14px + env(safe-area-inset-bottom) + var(--brf-float-lift,0px))!important;transform:none!important;'
    + 'transition:bottom .3s ease,opacity .2s ease!important}'
    + ':host .activator{width:52px!important;min-width:52px!important;height:52px!important;padding:0!important;border-radius:50%!important;justify-content:center!important;gap:0!important}'
    + ':host .activator__label,:host .activator .activator__label{display:none!important;max-width:0!important}'
    + ':host .activator{max-width:52px!important;transition:none!important}'
    + ':host .activator__icon{margin:0!important}}';
  function dress(root){
    var found = false;
    if (!root.getElementById('brf-ux-chat')) { var st = document.createElement('style'); st.id = 'brf-ux-chat'; st.textContent = CSS; root.appendChild(st); }
    if (root.querySelector('.activator')) found = true;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) if (all[i].shadowRoot && dress(all[i].shadowRoot)) found = true;
    return found;
  }
  var t0 = Date.now();
  function tick(){
    var c = document.querySelector('shopify-chat');
    if (c && !c.hasAttribute('data-brf-chat') && c.shadowRoot && dress(c.shadowRoot)) { c.setAttribute('data-brf-chat', ''); return; }
    if (c && Date.now() - t0 > 12000) { c.setAttribute('data-brf-chat', ''); return; } /* never leave it hidden */
    if (Date.now() - t0 < 30000) setTimeout(tick, 60); else document.documentElement.classList.add('brf-lc-chat-off');
  }
  tick();
})();

/* ===== from snippets/brf-load-calm.liquid ===== */
/* 2026-10-28 12:30 (Abid): stock count beside "Length (metres):" ("50 m in stock", the old Stock row hidden once it
   exists) and the main Add to bag shows the running total ("Add to bag | £11.97") as the length changes. Leaves the
   button alone while it's disabled or says anything other than "Add to bag" (sold out, choose options, added). */
(function(){
  if (window.__brfLiveCart) return; window.__brfLiveCart = 1;
  var doc = document, html = doc.documentElement, raf = 0;
  function form(){ return doc.querySelector('.product-block-list__item--info form[action*="/cart/add"]') || doc.querySelector('form.product-form[action*="/cart/add"]'); }
  function pence(t){ var m = (t || '').replace(/,/g, '').match(/(\d+)(?:\.(\d{1,2}))?/); return m ? (+m[1]) * 100 + (m[2] ? +(m[2] + '0').slice(0, 2) : 0) : null; }
  function money(p){ return '£' + (p / 100).toLocaleString('en-GB', {minimumFractionDigits: 2, maximumFractionDigits: 2}); }
  function stock(f){
    var q = f.querySelector('.product-form__info-item--quantity'), src = f.querySelector('.product-form__info-item .product-form__inventory');
    if (!q || !src) return;
    var lbl = q.querySelector(':scope > .product-form__info-title'), head = q.querySelector(':scope > .brf-qhead');
    if (!head) { if (!lbl) return; head = doc.createElement('div'); head.className = 'brf-qhead'; q.insertBefore(head, lbl); head.appendChild(lbl); }
    var out = head.querySelector('.brf-qstock');
    if (!out) { out = doc.createElement('span'); out.className = 'brf-qstock'; out.setAttribute('aria-live', 'polite'); head.appendChild(out); }
    var txt = src.textContent.replace(/\s+/g, ' ').trim().replace(/,\s*cut to your length/i, '').replace(/^In stock:\s*/i, '').replace(/\s*\bmetres?\b/i, 'm');
    if (/^\d/.test(txt)) txt += ' in stock';
    var cls = 'brf-qstock ' + (src.className.match(/inventory--\w+/) || ['inventory--high'])[0];
    if (out.textContent !== txt) out.textContent = txt;
    if (out.className !== cls) out.className = cls;
    var row = src.closest('.product-form__info-item'); if (row && !row.classList.contains('brf-stock-moved')) row.classList.add('brf-stock-moved');
    html.classList.add('brf-qstock-on');
  }
  function total(f){
    var btn = f.querySelector('.product-form__add-button'); if (!btn) return;
    var label = (btn.querySelector('.brf-atb__lbl') || btn).textContent.replace(/\s+/g, ' ').trim();
    if (btn.disabled || !/^Add to bag/i.test(label)) return;
    var pr = f.querySelector('.price-list .price--highlight, .price-list .price:not(.price--compare)'), unit = pence(pr && pr.textContent);
    var qi = f.querySelector('.product-form__info-item--quantity [name="quantity"]'), qty = Math.max(1, parseInt(qi && qi.value, 10) || 1);
    if (unit == null) return;
    var amt = money(unit * qty), cur = btn.querySelector('.brf-atb__amt');
    if (cur && cur.textContent === amt && btn.querySelector('.brf-atb__lbl')) return;
    btn.innerHTML = '<span class="brf-atb__lbl">Add to bag</span><span class="brf-atb__sep" aria-hidden="true"></span><span class="brf-atb__amt">' + amt + '</span>';
    btn.setAttribute('aria-label', 'Add to bag, ' + amt);
  }
  function run(){ raf = 0; var f = form(); if (!f) return; try { stock(f); } catch (e) {} try { total(f); } catch (e) {} }
  function soon(){ if (!raf) raf = requestAnimationFrame(run); }
  doc.addEventListener('input', function(e){ if (e.target && e.target.name === 'quantity') soon(); }, true);
  doc.addEventListener('change', soon, true);
  doc.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('.quantity-selector__button, .product-form__option, [data-brf-sw], .brf-dp__sw')) setTimeout(soon, 30); }, true);
  ['variant:changed', 'product:variant-change', 'cart:rerendered'].forEach(function(ev){ doc.addEventListener(ev, function(){ setTimeout(soon, 30); }); });
  function boot(){ if (!/\/products\//.test(location.pathname)) return; run(); new MutationObserver(soon).observe(doc.body, {childList: true, subtree: true, characterData: true}); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* ===== product page photo colour glow (2026-11-01, Abid). CSS at the end of brf-head-5.css.
   Desktop/tablet (768+): the main photo fills its rounded box and its colour spills out around it (.brf-phalo), drifting slowly.
   Phone layout (up to 999px, not smooth mode): the same colour glows behind the header glass bar (.brf-hglow) and spills
   into the top of the title glass card under it (.brf-tglow).
   All glows use one small 200px copy of each photo, preloaded up front, so swiping cross-fades straight away. ===== */
(function(){
  if (window.__brfPglass) return; window.__brfPglass = 1;
  var doc = document, root = doc.documentElement, cache = {}, layers = [], cur = '', gal, card, mg;
  function gsrc(img){
    var s = img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (!s || s.indexOf('data:') === 0) s = img.currentSrc || '';
    if (!s || s.indexOf('data:') === 0) return '';
    s = s.replace('{width}', '200');
    if (/[?&]width=\d+/.test(s)) s = s.replace(/([?&])width=\d+/, '$1width=200');
    else if (s.indexOf('/cdn/shop/') > -1) s += (s.indexOf('?') < 0 ? '?' : '&') + 'width=200';
    return s;
  }
  function pre(s, cb){
    var c = cache[s];
    if (c === true) { cb && cb(); return; }
    if (!c) {
      c = cache[s] = new Image(); c.__cbs = [];
      c.onload = c.onerror = function(){ var f = c.__cbs; cache[s] = true; for (var i = 0; i < f.length; i++) f[i](); };
      c.src = s;
    }
    if (cb) c.__cbs.push(cb);
  }
  function mk(cls, host, before){
    var el = doc.createElement('div'); el.className = cls; el.setAttribute('aria-hidden', 'true'); el.innerHTML = '<i></i><i></i>';
    host.insertBefore(el, before || null); var L = {el: el, n: 0, u: ''}; layers.push(L); if (cur) put(L, cur); return L;
  }
  function put(L, u){
    if (L.u === u) return; L.u = u;
    var a = L.el.children[L.n], b = L.el.children[1 - L.n];
    b.style.backgroundImage = 'url("' + u.replace(/"/g, '%22') + '")';
    requestAnimationFrame(function(){ if (L.u !== u) return; b.classList.add('is-on'); a.classList.remove('is-on'); });
    L.n = 1 - L.n;
  }
  function show(u){
    if (!u || u === cur) return; cur = u;
    pre(u, function(){ if (cur !== u) return; for (var i = 0; i < layers.length; i++) put(layers[i], u); });
  }
  function onShow(){
    if (!gal) return;
    var img = null;
    var tr = mg && mg.offsetParent && mg.querySelector('.brf-mg__track');
    if (tr && tr.clientWidth) {
      var k = Math.round(tr.scrollLeft / tr.clientWidth), li = tr.children[Math.max(0, Math.min(tr.children.length - 1, k))];
      img = li && li.querySelector('img');
    }
    if (!img) img = gal.querySelector('.product-gallery__carousel-item.is-selected img') || gal.querySelector('.product-gallery__carousel img');
    if (img) show(gsrc(img));
  }
  function setup(){
    gal = doc.querySelector('.product-block-list__item--gallery'); if (!gal || gal.closest('.modal')) { gal = null; return false; }
    card = gal.querySelector(':scope > .card'); mg = gal.querySelector('.brf-mg');
    if (card && !card.classList.contains('brf-pglass')) { card.classList.add('brf-pglass', 'is-live'); gal.classList.add('brf-phalo-host'); mk('brf-phalo', gal, card); }
    var hd = doc.getElementById('shopify-section-header');
    if (hd && !hd.querySelector(':scope > .brf-hglow')) { hd.classList.add('brf-hglow-host'); mk('brf-hglow', hd, hd.firstChild); }
    var tc = doc.querySelector('.product-block-list__item--info > .card');
    if (tc && !tc.querySelector(':scope > .brf-tglow')) { tc.classList.add('brf-tglow-host'); mk('brf-tglow', tc, tc.firstChild); }
    /* preload every photo's small copy so a swipe never waits for a download */
    var ims = gal.querySelectorAll('.product-gallery__carousel-item img, .brf-mg img');
    for (var i = 0; i < ims.length; i++) { var s = gsrc(ims[i]); if (s) pre(s); }
    return true;
  }
  function boot(){
    if (!doc.body || !doc.body.classList.contains('template-product') && !doc.querySelector('.template-product')) return;
    if (!setup()) return;
    onShow();
    /* desktop carousel: react the moment the selected slide changes */
    var car = gal.querySelector('.product-gallery__carousel');
    if (car && window.MutationObserver) new MutationObserver(onShow).observe(car, {attributes: true, attributeFilter: ['class'], subtree: true});
    /* phone swipe gallery: follow the scroll, switching as soon as the next photo passes halfway */
    doc.addEventListener('scroll', function(e){ var t = e.target; if (t && t.classList && t.classList.contains('brf-mg__track')) onShow(); }, {capture: true, passive: true});
    window.addEventListener('load', onShow);
    setInterval(function(){ if (!gal || !gal.isConnected) setup(); if (!mg && gal) mg = gal.querySelector('.brf-mg'); onShow(); }, 700);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
